var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            direction: "rtl",
            size: "50%",
            "modal-append-to-body": false,
            "before-close": _vm.handleClose,
            title: _vm.openType,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("billingPage.transactionForm"))),
          ]),
          _vm.drawer
            ? _c(
                "el-form",
                {
                  ref: "form",
                  staticStyle: { padding: "16px" },
                  attrs: {
                    "label-position": "top",
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.InvoicesNo"),
                            prop: "invoiceId",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t("billingPage.InvoicesNo"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.invoiceId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "invoiceId", $$v)
                              },
                              expression: "form.invoiceId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.Client"),
                            prop: "clientCode",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.clientCodeList,
                              placeholder: _vm.$t("chooseText"),
                            },
                            on: { change: _vm.getCategoryCodeList },
                            model: {
                              value: _vm.form.clientCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "clientCode", $$v)
                              },
                              expression: "form.clientCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.Category"),
                            prop: "categoryCode",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              disabled: !_vm.form.clientCode,
                              "option-list": _vm.categoryCodeList,
                              placeholder: _vm.$t("chooseText"),
                            },
                            model: {
                              value: _vm.form.categoryCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "categoryCode", $$v)
                              },
                              expression: "form.categoryCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.quantity"),
                            prop: "quantity",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: {
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.quantity,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "quantity", $$v)
                              },
                              expression: "form.quantity",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.PurchaseOrder"),
                            prop: "poId",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                              disabled: _vm.poDIS,
                            },
                            on: { change: _vm.poDISFUN },
                            model: {
                              value: _vm.form.poId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "poId", $$v)
                              },
                              expression: "form.poId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.OrderNumber"),
                            prop: "orderId",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                              disabled: _vm.orderDIS,
                            },
                            on: { change: _vm.orderDISFUN },
                            model: {
                              value: _vm.form.orderId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "orderId", $$v)
                              },
                              expression: "form.orderId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.ReturnOrder"),
                            prop: "returnOrderId",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                              disabled: _vm.returnOrderDIS,
                            },
                            on: { change: _vm.returnOrderDISFUN },
                            model: {
                              value: _vm.form.returnOrderId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "returnOrderId", $$v)
                              },
                              expression: "form.returnOrderId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.description"),
                            prop: "description",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              type: "textarea",
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "description", $$v)
                              },
                              expression: "form.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "foot" },
            [
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.onCancel } },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onComfirm } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }